import axios from 'axios'

export default {
  // ======================================================================
  // ==========================List Management=============================
  // ======================================================================
  // TODO: keep org list current all the time
  list (context, opts = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/organization', { params: { includeCounts: opts.includeCounts ?? false, scope: opts.scope } })
        .then(({ data }) => {
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  healthStatus (context, opts = {}) {
    // socket updates re-read the counts without naming a scope, so they keep the one the page last asked for
    const scope = opts.scope || context.state.healthScope
    context.commit('HEALTH_SCOPE', scope)
    return new Promise((resolve, reject) => {
      axios
        .get('/api/organization/health-status', { params: { scope } })
        .then(({ data }) => {
          context.commit('HEALTH', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  health (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/organization/health')
        .then(({ data }) => {
          context.commit('HEALTH_LIST', data)
          resolve()
        }).catch((error) => reject(error))
    })
  },
  async available (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/organization/available')
        .then(({ data }) => {
          context.commit('AVAILABLE_ORGS', data || [])
          resolve()
        }).catch((error) => reject(error))
    })
  },
  // ==========================Socket Updates==============================
  created (context, opts) {
    // TODO check socket after is_admin removed
    axios
      .get(`/api/organization/${opts}`, {
        params: { populate: ['user', 'system'] }
      })
      .then(({ data }) => {
        if (data.id) {
          context.commit('LIST_ADD', data)
          context.dispatch('healthStatus')
        }
      }).catch(() => {
      })
  },
  async updated (context, opts) {
    try {
      // TODO: check list for organization
      if (context.state.current && context.state.current.id === opts) {
        const { data } = await axios.get(`/api/organization/${opts}`, {
          params: { populate: ['user', 'system'] }
        })
        if (data.id) {
          context.commit('LIST_UPDATE', data)
          if (data.id === context.state.current.id) {
            context.commit('CURRENT', data)
          }
          context.dispatch('healthStatus')
        }
      }
    } catch (err) {}
  },
  destroyed (context, opts) {
    // always try to remove from list
    context.commit('LIST_REMOVE', opts)
    context.dispatch('healthStatus')
    if (opts === context.state.current.id) {
      context.commit('CURRENT', null)
    }
  },
  // ===========================List Edits===============================
  add (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/organization', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  delete (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/organization/${opts}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  // ======================================================================
  // ==========================Item Management=============================
  // ======================================================================
  detail (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/organization/${id}`, {
          params: { populate: ['user', 'system'] }
        })
        .then(({ data }) => {
          // context.commit('LIST_UPDATE', data)
          context.commit('CURRENT', data)
          context.commit('UserOrg/CURRENT', data.users, { root: true })
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  update (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/organization/${context.state.current.id}`, context.state.update)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  rpiUpdate (context, opts) {
    if (opts.id) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`/api/organization/${opts.id}`, { rpiMacAddress: opts.macAddress })
          .then(({ data }) => {
            resolve(data)
          }).catch((error) => reject(error))
      })
    }
  },
  clientKey (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/organization/${opts.id}/get-client-key`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  clientExe (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/client/make-exe', { params: opts })
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  clientExeUrl (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/client/get-exe-link?id=${opts.id}&model=organization`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  clientResetConnected (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/organization/${context.state.current.id}`, { keyConnected: false })
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  uploadKeys (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/organization/${opts.id}/get-upload-keys?name=${opts.file.name}&date=${opts.file.lastModified}&fileset=${opts.fileset}`)
        .then(({ data }) => {
          context.commit('UPDATE_BACKUP_METHOD')
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  rpiClientUpdate (context, opts) {
    return new Promise((resolve, reject) => {
      if (opts.organization && opts.macAddress) {
        axios
          .patch(`/api/organization/${opts.organization}`, { rpiMacAddress: opts.macAddress })
          .then(({ data }) => {
            resolve(data)
          }).catch((error) => reject(error))
      }
    })
  },
  // ======================================================================
  // ==========================User Management=============================
  // ======================================================================
  // findUsers (context, opts) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .get(`/api/organization/${opts}/findusers`)
  //       .then(({ data }) => {
  //         context.commit('USERS', data)
  //         resolve(data)
  //       }).catch((error) => reject(error))
  //   })
  // },
  addUser (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/userorg', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  updateUser (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .patch('/api/userorg', opts)
        .then(({ data }) => {
          // context.commit('Organization/UPDATE_USERS')
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  removeUser (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .delete('/api/userorg', { data: opts })
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  async clientSignal (context, opts) {
    try {
      const params = {
        id: opts.id,
        type: 'organization',
        signal: opts.signal
      }
      await axios.post('/api/client/signal', params)
    } catch (err) {
      console.log(err)
    }
  },
  resetAvailableOrgs (context, opts) {
    context.commit('RESET_AVAILABLE_ORGS')
  }
}
